import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Testimonials.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

const testimonials = [
  {
    name: "John Anderson",
    text: "The Golden Triangle Tour was perfectly organized. Delhi, Agra, and Jaipur were amazing, and the Taj Mahal exceeded all expectations!",
    image: "/Images/tour/man.png",
  },
  {
    name: "Priya Mehta",
    text: "Excellent budget tour with comfortable hotels and professional guides. Everything was smooth from pickup to drop.",
    image: "/Images/tour/woman.png",
  },
  {
    name: "David Wilson",
    text: "As a first-time visitor to India, this Golden Triangle itinerary was ideal. Great culture, history, and hospitality throughout the journey.",
    image: "/Images/tour/man.png",
  },
  {
    name: "Neha Kapoor",
    text: "Jaipur forts, Agra’s Taj Mahal, and Delhi sightseeing were beautifully planned. Highly recommended for families and couples.",
    image: "/Images/tour/woman.png",
  },
  {
    name: "Michael Brown",
    text: "Amazing value for money! Clean hotels, punctual drivers, and knowledgeable guides made our India trip unforgettable.",
    image: "/Images/tour/man.png",
  },
];

const Testimonials = () => {
  const swiperRef = useRef(null);

  return (
    <section className="testimonials">
      <h2 className="heading">
        Traveler Reviews from <span className="highlight">Golden Triangle Guests</span>
      </h2>

      <p className="subheading">
        Discover what travelers say about their unforgettable journey through
        Delhi, Agra, and Jaipur with our Budget Golden Triangle Tours.
      </p>

      <Swiper
        effect="coverflow"
        grabCursor
        centeredSlides={true}
        loop={true}
        slidesPerView={3}
        initialSlide={0}
        slidesPerGroup={1}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 150,
          modifier: 1,
          slideShadows: false,
          scale: 0.75,
        }}
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        navigation={{
          nextEl: ".testimonials-redesign .swiper-next",
          prevEl: ".testimonials-redesign .swiper-prev",
        }}
        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        {testimonials.map((t, idx) => (
          <SwiperSlide key={idx}>
            <div className="card">
              <div className="avatar-wrapper">
                <img src={t.image} alt={t.name} className="avatar" />
              </div>

              <p className="text">“{t.text}”</p>
              <h4 className="name">— {t.name}</h4>
            </div>
          </SwiperSlide>
        ))}

        <div
          className="swiper-prev"
          onClick={() => swiperRef.current?.slidePrev()}
        >
          <FaChevronLeft />
        </div>

        <div
          className="swiper-next"
          onClick={() => swiperRef.current?.slideNext()}
        >
          <FaChevronRight />
        </div>
      </Swiper>
    </section>
  );
};

export default Testimonials;